var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showTask ? _c('div', {
    staticClass: "content-task",
    on: {
      "click": _vm.clickTask
    }
  }, [_vm.status === 'noLogin' ? _c('div', {
    ref: "lottieContainer1",
    staticClass: "lottie-item",
    style: {
      backgroundImage: `url(${_vm.initialIcon})`
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.taskObj.login_text || '登录领奖'))])])]) : _vm._e(), _vm.status === 'init' ? _c('div', {
    ref: "lottieContainer2",
    staticClass: "lottie-item",
    style: {
      backgroundImage: `url(${_vm.initialIcon})`
    }
  }, [_c('div', {
    staticClass: "task-swiper-container"
  }, [_c('div', {
    ref: "swiper",
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v(_vm._s(_vm.taskObj.slide_text || '点击笔记'))]), _c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v(_vm._s(_vm.taskObj.slide_text_v2 || '点我领奖'))])])])]) : _vm._e(), _vm.status === 'finished' ? _c('div', {
    ref: "lottieContainer3",
    staticClass: "lottie-item",
    style: {
      backgroundImage: `url(${_vm.endIcon})`
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.taskObj.stop_text || '明日继续'))])])]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };